import { Outlet } from "@tanstack/react-router"
import { useCampaignLogsQuery } from "modules/campaigns/hooks/useCampaignLogsQuery"
import { Pagination } from "modules/shared/components/Pagination"
import { usePagination } from "modules/shared/hooks/usePagination"
import { Route } from "routes/_base/_auth/campaigns/$id/activity/route"
import { CampaignLogsTable } from "./Table"

type Props = {
  id: string
  search: ReturnType<typeof Route.useSearch>
  fullPath: string
}

const PAGE_SIZE = 50

function CampaignLogs({ id, search, fullPath }: Props) {
  const { page, setPage, setCount, count, totalPages } = usePagination({
    search,
    fullPath,
    total: PAGE_SIZE,
  })

  const { data, isPending } = useCampaignLogsQuery({
    id,
    query: {
      page,
      total: PAGE_SIZE,
      filterBy: search.filterBy,
    },
    onSuccess: (data) => setCount(data.pageInfo.count),
  })

  return (
    <>
      <CampaignLogsTable id={id} data={data ?? []} isPending={isPending} />
      <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} count={count} />
      <Outlet />
    </>
  )
}

export { CampaignLogs }
